module.exports = __webpack_public_path__ + "img/skyline-UserHeader.738318c3.jpg";